import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import Button from '@mui/material/Button';
import ConfirmButton from '../confirm-button';
import type { Event } from '../../types/Event';

type Props = {
  event: Event;
  children: React.ReactNode;
  buttonComponent?: React.ElementType;
  [key: string]: unknown;
};

const CopyEventButton = (props: Props) => {
  const { event, buttonComponent: ButtonComponent = Button, children, ...rest } = props;
  const router = useRouter();

  const handleCopy = useCallback((e) => {
    e.preventDefault();
    router.push(
      `/events/new?copyEventId=${event.id}`
    );
  }, [event, router]);

  if (event.series) {
    return (
      <ConfirmButton
        onClick={handleCopy}
        label={children}
        confirmMessage={`This event is part of a series. If you're adding another event to the series, click "Manage Series" instead to add a new event as part of the series. Events cannot be added retroactively to a series. Are you sure you wish to copy this event instead of adding to the series?`}
        buttonComponent={ButtonComponent}
        {...rest}
      />
    );
  }

  return (
    <ButtonComponent
      onClick={handleCopy}
      {...rest}
    >
      {children}
    </ButtonComponent>
  );
};

export default CopyEventButton;
